import { render, staticRenderFns } from "./veStuMoralResourceEdit.vue?vue&type=template&id=8c6a93f4&scoped=true"
import script from "./veStuMoralResourceEdit.vue?vue&type=script&lang=js"
export * from "./veStuMoralResourceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6a93f4",
  null
  
)

export default component.exports